export class BrowserNotificationManager {
    on_show_event;
    static max_simultaneous = 3;
    static available() {
        return window.Notification?.requestPermission != null;
    }
    _notifications;
    constructor(on_show_event) {
        this.on_show_event = on_show_event;
        const request = () => {
            document.removeEventListener('click', request);
            window.Notification.requestPermission((permission) => { });
        };
        document.addEventListener('click', request);
        this._notifications = [];
    }
    _remove_from_array(notification) {
        const index = this._notifications.indexOf(notification);
        if (index !== -1) {
            this._notifications.splice(index, 1);
        }
    }
    notify(event) {
        if (!document.hidden) {
            return;
        }
        try {
            const notification = new Notification(event.device_name ?? 'Важное событие!', {
                body: event.title,
                icon: event.icon != null
                    ? `${window.ZONT_URL.api_event_icon}?type=${event.icon}`
                    : undefined,
            });
            notification.addEventListener('click', () => {
                this._remove_from_array(notification);
                window.focus();
                this.on_show_event(event);
            });
            notification.addEventListener('close', () => {
                this._remove_from_array(notification);
            });
            this._notifications.push(notification);
            while (this._notifications.length > BrowserNotificationManager.max_simultaneous) {
                this._notifications.shift()?.close();
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
}
